export default{
  LOGIN_IN(state,token){
    state.UserToken=token
  },
  LOGIN_OUT(state){
    state.UserToken=''
  },
  IMAGE_IN(state,image){
    state.UserIMAGES=image
  },
  IMAGE_OUT(state){
    state.UserIMAGES=''
  },
  NAME_IN(state,name){
    state.UserName=name
  },
  NAME_OUT(state){
    state.UserName=''
  }
}